import * as React from 'react';
import {useEffect, useState} from 'react';
import {navigate} from "gatsby";

interface IProps {
    children: React.ReactElement | React.ReactElement[];
}

/**
 * Handles scrolling to an element if it has a data-anchor attribute matching the url hash
 *
 * @param {React.ReactElement<any, string | React.JSXElementConstructor<any>>} children
 * @returns {JSX.Element}
 * @constructor
 */
const AnchorScroll = ({children,}: IProps) => {
    const [anchor, setAnchor,] = useState(
        'undefined' !== typeof window && 2 < window.location.hash.length ? decodeURI(window.location.hash).slice(1) : ''
    );

    useEffect(() => {
        setAnchor(decodeURI(window.location.hash).slice(1));
    }, ['undefined' !== typeof window ? window.location.hash : null,]);

    useEffect(() => {
        if (!anchor || '' === anchor) {
            return;
        }
        const anchorElement = document.querySelector(`[data-anchor="${anchor}"]`);
        if (anchorElement) {
            anchorElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });

            // after scroll reset the hash so scroll can happen more than once to the same element
            setTimeout(() => {
                window.location.hash = ' ';
            }, 1000);
        } else {
            if (window.location.hash.startsWith('#destination=')) {
                navigate(window.location.hash.split('#destination=')[1]);
            }
        }
    }, [anchor,]);

    return <>{children}</>;
};

export default AnchorScroll;
